import React, { Component, Fragment } from 'react';
import CheckAuth from '../../../utils/hoc/CheckAuth'
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo';
import Loading from '../../../components/molecules/Loading';
import Button from '../../../components/atoms/Button';

class NotifikasiDetil extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	}

	componentDidMount = () => {
		this.props.setTitlePage({
			title : 'Detil Nofikasi',
			breadcrumb : [
				{name : 'Beranda', url : '/dashboard', status : false},
				{name : 'Notifikasi', url : '/notifikasi', status : false},
				{name : 'Detil Notifikasi', url : '/#', status : true},
			]
		})
	}

	render() {
		const {notif, status} = this.props;
		const notification = notif.list.filter(data => data.id === Number(this.props.match.params.id));
		return (
			<div className='detil-notifikasi'>
				{
					(notif.isLoading || status.loadingPage) ? <Loading /> : (notification.length > 0) && (
						<Fragment>
							<h2>{notification[0].subject}</h2>
							<span><i>Tgl. {dateFormatIndo(notification[0].createdAt, 'long', ' ', 'hm')}</i></span>
							<p>{notification[0].message}</p>
							<Button className="mt-4" width='small' color='blue' title='Kembali' onClick={()=>this.props.history.push('/notifikasi')}/>
							
						</Fragment>
					)
				}
				
			</div>
		);
	}
}




export default CheckAuth(NotifikasiDetil);